import React, { useState } from 'react'
import { Checkbox } from 'semantic-ui-react'

import { toast } from 'libs/toast'
import useAxios, { mutate } from 'hooks/useAxios'
import useSaveUserActivityLog, { ACTION_NAME } from 'hooks/useSaveUserActivityLog'

/**
 * @typedef {object} Survey
 * @property {number} id
 * @property {string} token
 *
 * @param {object} props
 * @param {Survey} props.survey
 * @param {string} props.label
 * @param {string} props.name
 * @param {boolean} props.defaultIsActive
 * @param {boolean} props.disabled
 */
export default function FollowupConversationOptionCheckbox({
  survey,
  label,
  name,
  defaultIsActive,
  disabled,
}) {
  const [isActive, setIsActive] = useState(defaultIsActive)
  const { fetch: updateSurveyIntegrationSettingAPI } = useAxios({
    url: `survey/survey-integration-setting/by-survey/${survey.token}/additional-option/`,
    method: 'patch',
    skip: true,
  })
  const saveUserActivityLog = useSaveUserActivityLog()

  /**
   *
   * @param {object} requestBody
   * @param {number} statusCode
   * @param {number} surveyId
   */
  function _saveUserActivityLog(requestBody, statusCode, surveyId) {
    const action = ACTION_NAME.connected_intercom

    const target = `sur_${surveyId}`
    saveUserActivityLog({
      action,
      target,
      statusCode,
      requestBody,
    })
  }

  function updateSurveyIntegrationSetting(_, { checked }) {
    setIsActive(checked)
    const data = {
      name: 'push_follow_up_conversation',
      integration_type: 'intercom',
      option_name: name,
      option_value: checked,
    }

    const logRequestBody = {
      integration: 'push_follow_up_conversation',
      enabled: checked,
    }

    updateSurveyIntegrationSettingAPI({
      data,
    })
      .then((response) => {
        toast.success('Settings updated.')

        mutate(
          'survey/survey-integration-setting/by-integration/?integration_type=intercom&name=push_follow_up_conversation'
        )
        _saveUserActivityLog(logRequestBody, response.status, survey.id)
      })
      .catch((error) => {
        toast.error(
          'Oops! Something went wrong. Please try again or contact Simplesat support for help.'
        )
        setIsActive(!checked)
        _saveUserActivityLog(logRequestBody, error.response.status, survey.id)
      })
  }

  return (
    <Checkbox
      checked={isActive}
      disabled={disabled}
      toggle
      label={label}
      name={name}
      onChange={updateSurveyIntegrationSetting}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomCreateFollowupConversationIntegration/FollowupConversationOptionCheckbox.js